import img1 from '../images/icon/icon1.png'
import img2 from '../images/icon/icon2.png'
import img3 from '../images/icon/icon3.png'
import img4 from '../images/icon/icon4.png'

const dataBox = [

    {
        id: 1,
        img: img1,
        title: 'Elite Vibes Only',
        desc: 'Every NXTLVL night is built different — premium crowds, no clout-chasers, just pure energy.'
    },
    {
        id: 2,
        img: img2,
        title: 'Top DJs & Sounds',
        desc: 'From reggaeton to hip-hop, we bring the beats that keep Orlando lit all night long.'
    },
    {
        id: 3,
        img: img3,
        title: 'Curated Venues',
        desc: 'We don’t do basic. Every venue is handpicked for maximum impact and unforgettable moments.'
    },
    {
        id: 4,
        img: img4,
        title: 'Loyal Community',
        desc: 'NXTLVL isn’t just a brand — it’s a movement. Our people come out every weekend, no cap.'
    },

]

export default dataBox;